import { render, staticRenderFns } from "./DisabledItems.vue?vue&type=template&id=670d255b&scoped=true&"
import script from "./DisabledItems.vue?vue&type=script&lang=js&"
export * from "./DisabledItems.vue?vue&type=script&lang=js&"
import style0 from "./DisabledItems.vue?vue&type=style&index=0&id=670d255b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d255b",
  null
  
)

export default component.exports